import { render, staticRenderFns } from "./ListWithIconError.vue?vue&type=template&id=12323b9d&"
import script from "./ListWithIconError.vue?vue&type=script&lang=js&"
export * from "./ListWithIconError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports